import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { BREAKPOINT_EXTRA_SMALL, CX, DEFAULT_THEME, THEMES } from '../../constants'
import Button from '../button'
import NavigationBarButton from '../navigation_bar_button'
import Search from '../search'
import Text from '../text'
import BackButton from '../back_button'
import { changeSetting } from '../../actions/settings'

class LoggedOutNavigationBar extends React.PureComponent {

  handleOnClickLightBulb = () => {
    let index = THEMES.findIndex((t) => t === this.props.theme)
    const nextIndex = (index === THEMES.length -1) ? 0 : index += 1
    const newTheme = THEMES[nextIndex]
    this.props.onChange('theme', newTheme)
  }

  render() {
    const { theme, width, title } = this.props

    // dont show back btn all footer bar tab titles or main page
    const footerBarTabTitles = ['Gab.com', 'Groups', 'News', 'Feeds', 'Marketplace', 'Search']
    const shouldShowBackBtn = footerBarTabTitles.indexOf(title) === -1
    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const isSlim = false // title === 'Explore'

    if (isXS) {
      return (
        <div className={[_s.d, _s.z4, _s.minH98PX, _s.w100PC].join(' ')}>
          <div className={[_s.d, _s.minH98PX, _s.bgNavigation, _s.aiCenter, _s.z3, _s.top0, _s.right0, _s.left0, _s.posFixed].join(' ')}>
            <div className={[_s.d, _s.w100PC, _s.flexRow, _s.flexWrap, _s.h100PC].join(' ')}>
              <div className={[_s.d, _s.flexRow, _s.saveAreaInsetPT, _s.saveAreaInsetPL, _s.saveAreaInsetPR, _s.w100PC].join(' ')}>

                {
                  shouldShowBackBtn &&
                  <BackButton
                    className={[_s.h53PX, _s.pl10].join(' ')}
                    icon='angle-left'
                    iconSize='18px'
                    iconClassName={[_s.mr5, _s.fillNavigation].join(' ')}
                  />
                }
  
                <div className={[_s.d, _s.pl10].join(' ')}>
                  <Button
                    noClasses
                    href='/'
                    color='none'
                    backgroundColor='none'
                    icon='logo'
                    title='Gab'
                    iconClassName={[_s.fillBrand].join(' ')}
                    className={[_s.d, _s.h53PX, _s.aiCenter, _s.jcCenter, _s.cursorPointer, _s.outlineNone, _s.bgTransparent, _s.py5, _s.mr5, _s.pl0].join(' ')}
                  />
                </div>
  
                <div className={[_s.d, _s.flexGrow1, _s.pr10, _s.mrAuto].join(' ')}>
                  <Search isInNav />
                </div>
  
              </div>
  
              <div className={[_s.d, _s.flexRow, _s.pb5, _s.px10, _s.w100PC].join(' ')}>
                <Button
                  isNarrow
                  isOutline
                  radiusSmall
                  color='brand'
                  backgroundColor='none'
                  href='/auth/sign_in'
                  className={[_s.borderColorWhite, _s.mr5, _s.flexGrow1, _s.aiCenter, _s.jcCenter, _s.py7].join(' ')}
                >
                  <Text color='inherit' weight='medium' align='center'>
                    Log in
                  </Text>
                </Button>
  
                <Button
                  isNarrow
                  radiusSmall
                  color='white'
                  backgroundColor='brand'
                  href='/auth/sign_up'
                  className={[_s.jcCenter, _s.aiCenter, _s.ml5, _s.flexGrow1, _s.py7].join(' ')}
                >
                  <Text color='inherit' weight='bold' align='center'>
                    Sign up
                  </Text>
                </Button>
  
              </div>
            </div>
  
          </div>
        </div>
      )
    }

    const wrapperClasses = CX({
      d: 1,
      flexRow: 1,
      h100PC: 1,
      px15: !isSlim,
      w100PC: !isSlim,
      w1255PX: isSlim,
      mlAuto: isSlim,
      mrAuto: isSlim,
    })

    return (
      <div className={[_s.d, _s.z4, _s.minH53PX, _s.w100PC].join(' ')}>
        <div className={[_s.d, _s.minH53PX, _s.bgNavigation, _s.aiCenter, _s.z3, _s.top0, _s.right0, _s.left0, _s.posFixed].join(' ')}>
          <div className={wrapperClasses}>
            <div className={[_s.d, _s.aiCenter, _s.flexRow, _s.flexGrow1, _s.saveAreaInsetPT, _s.saveAreaInsetPL, _s.saveAreaInsetPR].join(' ')}>
              <div className={[_s.d, _s.aiCenter, _s.flexRow].join(' ')}>
                <div className={[_s.d, _s.flexRow, _s.w330PX, _s.mrAuto].join(' ')}>
                  <Button
                    noClasses
                    href='/'
                    color='none'
                    backgroundColor='none'
                    icon='logo'
                    title='Gab'
                    iconClassName={[_s.fillNavigationBrand].join(' ')}
                    className={[_s.d, _s.h53PX, _s.aiCenter, _s.jcCenter, _s.cursorPointer, _s.outlineNone, _s.bgTransparent, _s.py5, _s.mr5, _s.pl0].join(' ')}
                  />
                  <div className={[_s.d, _s.flexGrow1, _s.pl10, _s.mrAuto].join(' ')}>
                    <Search isInNav />
                  </div>
                </div>
              </div>

              <div className={[_s.d, _s.flexRow, _s.mlAuto, _s.mrAuto].join(' ')}>
                <NavigationBarButton isMD title='Home' icon='home' href='/home' />
                <NavigationBarButton isMD title='Clips' icon='apps' href='/timeline/clips' />
                <NavigationBarButton isMD title='Groups' icon='group' href='/groups' />
                <NavigationBarButton isMD title='News' icon='news' to='/news' />
                <NavigationBarButton isMD title='Businesses' icon='apps' to='/businesses' />
                <NavigationBarButton isMD title='Marketplace' icon='shop' to='/marketplace' />
              </div>

              <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.jcCenter, _s.w330PX, _s.mlAuto, _s.h100PC].join(' ')}>
                <div className={[_s.d, _s.h53PX, _s.flexRow, _s.flexGrow1, _s.mr10, _s.py5].join(' ')}>
                  <Button
                    isNarrow
                    isOutline
                    radiusSmall
                    color='brand'
                    backgroundColor={theme === 'light' ? 'white' : 'none'}
                    href='/auth/sign_in'
                    className={[_s.borderColorWhite, _s.mr5, _s.flexGrow1, _s.aiCenter, _s.jcCenter, _s.py5].join(' ')}
                  >
                    <Text color='inherit' size='medium' weight='medium' align='center'>
                      Log in
                    </Text>
                  </Button>

                  <Button
                    isNarrow
                    radiusSmall
                    isOutline={theme === 'light'}
                    color='white'
                    backgroundColor={theme === 'light' ? 'none' : 'brand'}
                    href='/auth/sign_up'
                    className={[_s.jcCenter, _s.aiCenter, _s.ml5, _s.flexGrow1, _s.py5].join(' ')}
                  >
                    <Text color='inherit' size='medium' weight='bold' align='center'>
                      Sign up
                    </Text>
                  </Button>
                </div>
                
                <NavigationBarButton attrTitle='Dark/Muted/Light/White Mode' icon='light-bulb' onClick={this.handleOnClickLightBulb} />

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

LoggedOutNavigationBar.propTypes = {
  title: PropTypes.string,
}

const mapStateToProps = (state) => ({
  theme: state.getIn(['settings', 'displayOptions', 'theme'], DEFAULT_THEME),
  width: state.getIn(['settings', 'window_dimensions', 'width'])
})

const mapDispatchToProps = (dispatch) => ({
  onChange(key, value) {
    dispatch(changeSetting(['displayOptions', key], value))
  },
})


export default connect(mapStateToProps, mapDispatchToProps)(LoggedOutNavigationBar)